export function openModal(
  html: string,
  onMount?: (body: HTMLElement, close: () => void) => void
): () => void {
  const root = document.getElementById('modal-root')!;
  root.innerHTML = `
    <div class="modal-backdrop">
      <div class="modal">
        <button class="modal-close" aria-label="Close">&times;</button>
        <div class="modal-body">${html}</div>
      </div>
    </div>
  `;

  const close = () => {
    root.innerHTML = '';
  };

  root.querySelector('.modal-backdrop')!.addEventListener('click', (e) => {
    if (e.target === e.currentTarget) close();
  });
  root.querySelector('.modal-close')!.addEventListener('click', close);

  document.addEventListener('keydown', function esc(e) {
    if (e.key === 'Escape') {
      close();
      document.removeEventListener('keydown', esc);
    }
  });

  const body = root.querySelector('.modal-body') as HTMLElement;
  if (onMount) onMount(body, close);
  return close;
}
